// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.ed-layout {
  z-index: 100;
  text-rendering: optimizeSpeed;
  line-height: 95%;
  font-family: 'DM Mono', monospace;
  font-size: 0.85em;
  color: #ffffff;
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
}
.ed-layout * {
  pointer-events: all;
  box-sizing: border-box;
}
.ed-layout-dragging {
  pointer-events: all;
  cursor: ew-resize;
}
.ed-layout-dragging * {
  pointer-events: none !important;
}
.ed-full-w {
  width: 100%;
}
.ed-flex-left,
.ed-input-wrap {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: flex-end;
}
.ed-flex-right,
.ed-in-wrap {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.ed-flex-down {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.ed-in-wrap {
  font-size: 0.9em;
  width: 100%;
  padding: 0px 0.425em;
  min-height: 1.6em;
  flex-wrap: nowrap;
  margin-bottom: 0.255em;
}
.ed-in-wrap.ed-in-half {
  width: 50%;
}
.ed-in-wrap.ed-tight {
  min-height: 1em;
}
.ed-in-wrap:last-child {
  margin-bottom: 0.425em;
}
.ed-in-wrap-toggle {
  cursor: pointer;
}
.ed-in-wrap-toggle-input {
  width: auto;
  flex-shrink: 0;
}
.ed-in-wrap-toggle-label {
  width: auto;
}
.ed-input-wrap {
  width: 100%;
  flex-shrink: 1;
  max-width: 60%;
  min-width: 150px;
}
.ed-input-wrap.ed-in-half {
  width: -webkit-fill-available;
  max-width: -webkit-fill-available;
}
.ed-in-full {
  max-width: 100%;
  width: 100%;
}
.ed-in-label {
  width: fit-content;
  max-width: 150px;
  flex-shrink: 2;
  padding-left: 0.4em;
  color: #c8c8c8;
  white-space: normal;
  text-align: -webkit-left;
  align-items: flex-start;
  justify-content: flex-start;
  word-break: break-all;
}
.ed-in-label-colon {
  color: #c8c8c8;
}
input:disabled {
  color: #c8c8c8 !important;
  -webkit-user-select: none !important;
  user-select: none !important;
  cursor: default !important;
}
.ed-in-disabled {
  pointer-events: none;
  cursor: not-allowed !important;
}
.ed-in-disabled * {
  cursor: not-allowed !important;
}
.ed-input {
  width: 100%;
  line-height: 1.6em;
  height: 1.6em;
  user-select: all;
  font-size: inherit;
  font-family: 'DM Mono', monospace;
  -webkit-appearance: none;
  outline: none;
  color: #ffffff;
  background-color: #141414;
  border: none;
  border-radius: none;
  white-space: pre;
  padding: 0px 0.425em;
  text-align: end;
  overflow-y: hidden;
  overflow-x: auto;
}
.ed-input-plain {
  background-color: #1e1e1e;
}
.ed-toggle-outer {
  width: 1.6em;
  cursor: pointer;
  height: 1.6em;
  background-color: #141414;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ed-toggle-outer .ed-toggle-inner {
  width: 0.8em;
  height: 0.8em;
  border-radius: 0.8em;
  background-color: #2a2a2a;
}
.ed-toggle-outer .ed-toggle-inner.ed-toggle-active {
  background: #ffffff;
}
.ed-box-title {
  padding: 0.425em;
  padding-bottom: 0.425em/2;
  font-weight: 800;
  text-align: center;
  display: flex;
  color: white;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;
  z-index: 1;
  background: #2a2a2a;
  text-transform: uppercase !important;
}
.ed-box-title * {
  white-space: pre;
}
.ed-box-title .ed-in-label-colon {
  color: #c8c8c8;
}
.ed-box-title-sticky {
  position: sticky;
  top: 0px;
  background: #ffffff;
  color: #2a2a2a;
  margin-bottom: 0.425em;
}
.ed-box-content {
  display: flex;
  align-self: start;
  justify-content: start;
  flex-direction: row;
  flex-wrap: wrap;
}
.ed-box::-webkit-scrollbar,
.ed-menu::-webkit-scrollbar,
.ed-input::-webkit-scrollbar {
  -webkit-appearance: none;
  background-color: #141414;
  width: 4px;
  height: 4px;
  border-radius: 0px;
}
.ed-box::-webkit-scrollbar-corner,
.ed-menu::-webkit-scrollbar-corner,
.ed-input::-webkit-scrollbar-corner {
  background-color: #141414;
}
.ed-box::-webkit-scrollbar-thumb,
.ed-menu::-webkit-scrollbar-thumb,
.ed-input::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: #7F7F7F;
}
.ed-box::-webkit-scrollbar-thumb:hover,
.ed-menu::-webkit-scrollbar-thumb:hover,
.ed-input::-webkit-scrollbar-thumb:hover {
  background-color: #8F8F8F;
}
.ed-box {
  overflow-y: scroll;
  background-color: #2a2a2a;
  color: #ffffff;
  position: fixed;
  width: 300px;
  flex-wrap: nowrap;
}
.ed-box text {
  margin-left: 10px;
}
.ed-box.ed-scroll {
  overflow-y: scroll;
  overflow-x: hidden;
  width: 324px;
}
.ed-box .ed-description {
  padding: 0px 0.425em;
  font-size: 0.8em;
  color: #ebebeb;
  margin: 0.425em 0px;
  margin-top: 0px;
  white-space: normal;
}
.ed-menu-child-wrapper {
  position: relative;
  left: -100%;
  top: 12px;
}
.ed-menu {
  color: #ffffff;
  flex-wrap: nowrap;
  width: fit-content;
  height: fit-content;
  position: fixed;
}
.ed-menu.ed-scroll {
  overflow-y: scroll;
  overflow-x: hidden;
}
.ed-menu.ed-flex-down > .ed-menu-item {
  width: -webkit-fill-available;
  height: auto;
}
.ed-menu.ed-flex-right > .ed-menu-item {
  height: -webkit-fill-available;
  width: auto;
}
.ed-menu .ed-menu-labels {
  background-color: #2a2a2a;
}
.ed-menu .ed-menu-item-label {
  white-space: pre;
  width: -webkit-fill-available;
  height: 1.6em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  color: #ebebeb;
  background: none;
  border: none;
  outline: none;
  font: inherit;
  padding: 0px;
  cursor: pointer;
}
.ed-menu .ed-menu-item-label.ed-selected {
  background-color: #141414;
  color: #ffffff !important;
}
.ed-menu .ed-menu-item-label:hover {
  color: #ffffff;
  background: #1e1e1e;
}
.ed-menu .ed-menu-item-box {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ebebeb;
  background: none;
  outline: none;
  padding: 0px;
  border: none;
}
.ed-menu .ed-menu-item-box * {
  pointer-events: none;
}
.ed-menu .ed-menu-item-box.ed-selected {
  background: #ebebeb;
  color: #141414 !important;
}
.ed-menu .ed-menu-item {
  position: relative;
}
.ed-menu.ed-menu-alt > .ed-menu-labels > .ed-menu-item-label {
  background-color: #141414;
}
.ed-menu.ed-menu-alt > .ed-menu-labels > .ed-menu-item-label.ed-selected {
  background-color: #2a2a2a;
}
.ed-hidden {
  visibility: hidden;
}
.ed-range-outer {
  height: 1.6em;
  width: 100%;
  background: #141414;
  position: relative;
  cursor: ew-resize;
}
.ed-range-outer .ed-range-slider {
  width: 6.5px;
  height: 1.6em;
  background: #ffffff;
}
.ed-range-outer .ed-range-slider.ed-active {
  background: #ffffff;
}
.ed-range-outer .ed-range-value {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translate(0%, -50%);
}
.ed-range-outer .ed-range-value.ed-range-value-snap {
  right: 8px;
  left: initial;
}
.ed-range-outer .ed-range-value.ed-range-value-left {
  right: 14px;
  left: initial;
}
.ed-range-outer .ed-range-value.ed-range-value-left.ed-range-value-snap {
  left: 8px;
  right: initial;
}
.ed-button {
  outline: none;
  -webkit-appearance: none;
  font: inherit;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 1.6em;
  background: #141414;
  color: #ebebeb;
}
.ed-button:hover {
  color: #ffffff;
}
.ed-color-box {
  position: relative;
  -webkit-appearance: none;
  width: 3.2em;
  height: 1.6em;
  flex-shrink: 0;
  cursor: pointer;
  margin-right: 0.255em;
  border: 3px solid black;
}
.ed-color-box .ed-color-box-input {
  visibility: visible;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 0px;
  left: 0px;
  top: 0px;
}
.ed-value-box {
  width: 100%;
  height: 1.6em;
  background-color: #2a2a2a;
  margin-left: 0.153em;
  line-height: 1.6em;
  padding: 0px 0.425em;
}
.ed-section {
  margin: 0.425em 0px;
  padding: 0.425em 0px;
  position: relative;
  border-top: 1px solid rgba(150, 150, 150, 0.3);
  border-bottom: 1px solid rgba(150, 150, 150, 0.3);
}
.ed-section-title {
  min-height: 1.6em;
  cursor: pointer;
  white-space: pre;
  font-weight: 800;
  width: 100%;
  padding: 0px 0.425em;
  text-transform: uppercase;
}
.ed-section-label-toggle-off {
  cursor: default;
}
.ed-section-label-toggle {
  font-size: 0.85em;
  width: 100%;
  padding-right: 0.425em;
  display: flex;
  color: #c8c8c8;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
}
.ed-section-label-toggle.ed-section-label-toggle-active {
  color: #ebebeb;
}
.ed-section-end-label {
  padding: 0.425em;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.ed-input-select {
  width: 100%;
  outline: none;
  -webkit-appearance: none;
  height: 24px;
  cursor: pointer;
  padding: 0px 0.425em;
  border: none;
  color: #ffffff;
  background: #141414;
}
.ed-input-select-arrow {
  position: absolute;
  right: 14px;
  color: #c8c8c8;
  font-family: monospace;
}
.ed-separator {
  margin-top: 1.6em / 3;
  border-bottom: 1px solid rgba(150, 150, 150, 0.3);
  height: 0px;
  width: 100%;
  margin-bottom: 1.6em / 2;
}
.ed-line-chart {
  width: 100%;
  height: 80px;
  background: #141414;
}
.ed-line-chart-wrap {
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: flex-start;
}
.ed-line-chart-wrap canvas {
  cursor: ew-resize;
  width: 100%;
  height: 100%;
}
.ed-line-chart-label {
  padding: 0.425em 0px;
}
.ed-anchor {
  display: flex;
  flex-direction: row;
  position: fixed;
}
.ed-anchor .ed-anchor-handle {
  position: fixed;
  background: black;
  cursor: move;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.ed-anchor .ed-anchor-handle .ed-anchor-dot {
  margin: 0.26666667em;
  pointer-events: none;
  background: white;
  width: 0.26666667em;
  height: 0.26666667em;
}
.ed-anchor .ed-anchor-handle-resize {
  width: 0.8em;
  height: 0.8em;
  background: black;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.ed-anchor.ed-anchor-drag {
  pointer-events: all;
  cursor: move;
}
.ed-anchor.ed-anchor-drag * {
  pointer-events: none !important;
}
.ed-anchor.ed-anchor-resize {
  pointer-events: all;
}
.ed-anchor.ed-anchor-resize * {
  pointer-events: none !important;
}
`, "",{"version":3,"sources":["webpack://./components/Style.less"],"names":[],"mappings":"AAiBA;EACC,2BAAA;EAhBC,eAAe;EAkBhB,yBAAA;EAhBC,WAAW;EAkBZ,wBAAA;EAhBC,mBAAmB;EAkBpB,sBAAA;EAhBC,4BAA4B;EAkB7B,qBAAA;EAhBC,2BAA2B;EAkB5B,iBAAA;EAhBC;gFAC8E;AAChF;AAmBA;EACC,YAAA;EAEA,6BAAA;EACA,gBAAA;EACA,iCAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AAlBD;AAIA;EAiBE,mBAAA;EACA,sBAAA;AAlBF;AAsBA;EACC,mBAAA;EACA,iBAAA;AApBD;AAkBA;EAKE,+BAAA;AApBF;AAwBA;EACC,WAAA;AAtBD;AAyBA;;EACC,aAAA;EACA,eAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;AAtBD;AAyBA;;EACC,aAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,2BAAA;AAvBD;AA0BA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAxBD;AA2BA;EACC,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EAEA,iBAAA;EAEA,sBAAA;AA3BD;AA6BC;EACC,UAAA;AA3BF;AA8BC;EACC,eAAA;AA5BF;AA+BC;EACC,sBAAA;AA7BF;AAiCA;EACC,eAAA;AA/BD;AAkCA;EACC,WAAA;EACA,cAAA;AAhCD;AAoCA;EACC,WAAA;AAlCD;AAqCA;EAGC,WAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AArCD;AAuCC;EACC,6BAAA;EACA,iCAAA;AArCF;AAyCA;EACC,eAAA;EACA,WAAA;AAvCD;AA0CA;EACC,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;AAxCD;AA2CA;EACC,cAAA;AAzCD;AA4CA;EACC,yBAAA;EACA,oCAAA;EACA,4BAAA;EACA,0BAAA;AA1CD;AA6CA;EACC,oBAAA;EACA,8BAAA;AA3CD;AAyCA;EAKE,8BAAA;AA3CF;AA+CA;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,wBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA7CD;AAkDA;EACC,yBAAA;AAhDD;AAmDA;EACC,YAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjDD;AA0CA;EAUE,YAAA;EACA,aAAA;EACA,oBAAA;EACA,yBAAA;AAjDF;AAmDE;EACC,mBAAA;AAjDH;AAsDA;EAEC,gBAAA;EACA,yBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EAMA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EAEA,UAAA;EACA,mBAAA;EAMA,oCAAA;AAjED;AAuCA;EAWE,gBAAA;AA/CF;AAoCA;EAuBE,cAAA;AAxDF;AA8DA;EACC,gBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;AA5DD;AA+DA;EAEC,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AA9DD;AAqEC;;;EACC,wBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAjEF;AAoEC;;;EACC,yBAAA;AAhEF;AAmEC;;;EACC,kBAAA;EACA,yBAAA;AA/DF;AAiEE;;;EACC,yBAAA;AA7DH;AAkEA;EAKC,kBAAA;EAUA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EAKA,iBAAA;AAjFD;AA0DA;EAEE,iBAAA;AAzDF;AA8DC;EACC,kBAAA;EACA,kBAAA;EACA,YAAA;AA5DF;AAkDA;EA0BE,oBAAA;EAEA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AA1EF;AAkFA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;AAhFD;AAmFA;EAEC,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAlFD;AAoFC;EACC,kBAAA;EACA,kBAAA;AAlFF;AAqFC;EAEE,6BAAA;EACA,YAAA;AApFH;AAwFC;EAEE,8BAAA;EACA,WAAA;AAvFH;AAgEA;EA4BE,yBAAA;AAzFF;AA6DA;EAiCE,gBAAA;EAGA,6BAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EAQA,eAAA;AApGF;AA8FE;EACC,yBAAA;EAEA,yBAAA;AA7FH;AAmGE;EACC,cAAA;EACA,mBAAA;AAjGH;AAsCA;EAiEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AApGF;AA4BA;EA2EG,oBAAA;AApGH;AAuGE;EACC,mBAAA;EACA,yBAAA;AArGH;AAqBA;EAuFE,kBAAA;AAzGF;AA4GC;EAGE,yBAAA;AA5GH;AAyGC;EAOE,yBAAA;AA7GH;AAwHA;EACC,kBAAA;AAtHD;AAyHA;EACC,aAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EAoCA,iBAAA;AA1JD;AAkHA;EAOE,YAAA;EACA,aAAA;EACA,mBAAA;AAtHF;AAwHE;EACC,mBAAA;AAtHH;AA0GA;EAkBE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,8BAAA;AAzHF;AA2HE;EACC,UAAA;EACA,aAAA;AAzHH;AA4HE;EACC,WAAA;EACA,aAAA;AA1HH;AA4HG;EACC,SAAA;EACA,cAAA;AA1HJ;AAmIA;EACC,aAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAjID;AAmIC;EACC,cAAA;AAjIF;AAqIA;EACC,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;AAnID;AA2HA;EAWE,mBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AAnIF;AAuIA;EACC,WAAA;EAEA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAtID;AA2IA;EAEC,mBAAA;EACA,oBAAA;EACA,kBAAA;EAIA,8CAAA;EACA,iDAAA;AA7ID;AAkJA;EACC,iBAAA;EACA,eAAA;EACA,gBAAA;EAEA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,yBAAA;AAjJD;AAoJA;EACC,eAAA;AAlJD;AAqJA;EACC,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;AAnJD;AAqJC;EACC,cAAA;AAnJF;AAuJA;EACC,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AArJD;AAyJA;EACC,WAAA;EACA,aAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAvJD;AA0JA;EACC,kBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;AAxJD;AA4JA;EACC,qBAAA;EACA,iDAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;AA1JD;AA6JA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AA3JD;AA8JA;EACC,sBAAA;EACA,yBAAA;EACA,2BAAA;EACA,uBAAA;AA5JD;AAwJA;EAOE,iBAAA;EACA,WAAA;EACA,YAAA;AA5JF;AAgKA;EAEC,oBAAA;AA/JD;AAkKA;EACC,aAAA;EACA,mBAAA;EACA,eAAA;AAhKD;AA6JA;EAME,eAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAhKF;AAoJA;EAeG,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AAhKH;AA6IA;EA0BE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EAEA,MAAA;EACA,OAAA;EACA,UAAA;AArKF;AAwKC;EACC,mBAAA;EACA,YAAA;AAtKF;AAoKC;EAKE,+BAAA;AAtKH;AA0KC;EACC,mBAAA;AAxKF;AAuKC;EAKE,+BAAA;AAzKH","sourcesContent":["@bg1: rgba(42, 42, 42, 1.0);\n@bg2: rgba(20, 20, 20, 1.0);\n@bg3: rgba(30, 30, 30, 1.0);\n\n@color1: rgb(255, 255, 255);\n@color2: rgb(235, 235, 235);\n@color3: rgb(200, 200, 200);\n@color4: rgba(150, 150, 150, 0.3);\n\n@mainfont: 'DM Mono', monospace;\n@fontsize: .85em;\n@padding: @fontsize*.5;\n@padding2: @fontsize;\n@margin: @padding*.6;\n@dim: 1.60em;\n\n\n.noselect {\n\t-webkit-touch-callout: none;\n\t/* iOS Safari */\n\t-webkit-user-select: none;\n\t/* Safari */\n\t-khtml-user-select: none;\n\t/* Konqueror HTML */\n\t-moz-user-select: none;\n\t/* Old versions of Firefox */\n\t-ms-user-select: none;\n\t/* Internet Explorer/Edge */\n\tuser-select: none;\n\t/* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n}\n\n.ed-layout {\n\tz-index: 100;\n\t// transform: translate3D(0.0px,0.0px,0.0px);\n\ttext-rendering: optimizeSpeed;\n\tline-height: 95%;\n\tfont-family: @mainfont;\n\tfont-size: @fontsize;\n\tcolor: @color1;\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n\tpointer-events: none;\n\n\t* {\n\t\tpointer-events: all;\n\t\tbox-sizing: border-box;\n\t}\n}\n\n.ed-layout-dragging {\n\tpointer-events: all;\n\tcursor: ew-resize;\n\n\t* {\n\t\tpointer-events: none !important;\n\t}\n}\n\n.ed-full-w {\n\twidth: 100%;\n}\n\n.ed-flex-left {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tposition: relative;\n\tflex-direction: row-reverse;\n\talign-items: center;\n\tjustify-content: flex-end;\n}\n\n.ed-flex-right {\n\tdisplay: flex;\n\tposition: relative;\n\t// flex-wrap: wrap;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: flex-start;\n}\n\n.ed-flex-down {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n}\n\n.ed-in-wrap {\n\tfont-size: .9em;\n\twidth: 100%;\n\tpadding: 0px @padding;\n\tmin-height: @dim;\n\t&:extend(.ed-flex-right);\n\tflex-wrap: nowrap;\n\t// margin-top: @padding;\n\tmargin-bottom: @margin;\n\n\t&.ed-in-half {\n\t\twidth: 50%;\n\t}\n\n\t&.ed-tight {\n\t\tmin-height: 1em;\n\t}\n\n\t&:last-child {\n\t\tmargin-bottom: 0.425em;\n\t}\n}\n\n.ed-in-wrap-toggle {\n\tcursor: pointer;\n}\n\n.ed-in-wrap-toggle-input {\n\twidth: auto;\n\tflex-shrink: 0;\n\t// margin-right: 4px;\n}\n\n.ed-in-wrap-toggle-label {\n\twidth: auto;\n}\n\n.ed-input-wrap {\n\n\t&:extend(.ed-flex-left);\n\twidth: 100%;\n\tflex-shrink: 1;\n\tmax-width: 60%;\n\tmin-width: 150px;\n\n\t&.ed-in-half {\n\t\twidth: -webkit-fill-available;\n\t\tmax-width: -webkit-fill-available;\n\t}\n}\n\n.ed-in-full {\n\tmax-width: 100%;\n\twidth: 100%;\n}\n\n.ed-in-label {\n\twidth: fit-content;\n\tmax-width: 150px;\n\tflex-shrink: 2;\n\tpadding-left: 0.4em;\n\tcolor: @color3;\n\twhite-space: normal;\n\ttext-align: -webkit-left;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tword-break: break-all;\n}\n\n.ed-in-label-colon {\n\tcolor: @color3;\n}\n\ninput:disabled {\n\tcolor: @color3 !important;\n\t-webkit-user-select: none !important;\n\tuser-select: none !important;\n\tcursor: default !important;\n}\n\n.ed-in-disabled {\n\tpointer-events: none;\n\tcursor: not-allowed !important;\n\n\t* {\n\t\tcursor: not-allowed !important;\n\t}\n}\n\n.ed-input {\n\twidth: 100%;\n\tline-height: @dim;\n\theight: @dim;\n\tuser-select: all;\n\tfont-size: inherit;\n\tfont-family: @mainfont;\n\t-webkit-appearance: none;\n\toutline: none;\n\tcolor: @color1;\n\tbackground-color: @bg2;\n\tborder: none;\n\tborder-radius: none;\n\twhite-space: pre;\n\tpadding: 0px @padding;\n\ttext-align: end;\n\toverflow-y: hidden;\n\toverflow-x: auto;\n\t// margin-left: @padding2;\n\n}\n\n.ed-input-plain {\n\tbackground-color: @bg3;\n}\n\n.ed-toggle-outer {\n\twidth: @dim;\n\tcursor: pointer;\n\theight: @dim;\n\tbackground-color: @bg2;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.ed-toggle-inner {\n\t\twidth: (@dim/2);\n\t\theight: (@dim/2);\n\t\tborder-radius: (@dim/2);\n\t\tbackground-color: @bg1;\n\n\t\t&.ed-toggle-active {\n\t\t\tbackground: @color1;\n\t\t}\n\t}\n}\n\n.ed-box-title {\n\n\tpadding: @padding;\n\tpadding-bottom: @padding/2;\n\t// margin-bottom: @padding;\n\tfont-weight: 800;\n\ttext-align: center;\n\tdisplay: flex;\n\tcolor: white;\n\n\t* {\n\t\twhite-space: pre;\n\t}\n\n\talign-items:flex-start;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\twidth: 100%;\n\n\tz-index: 1;\n\tbackground: @bg1;\n\n\t.ed-in-label-colon {\n\t\tcolor: @color3;\n\t}\n\n\ttext-transform: uppercase !important;\n}\n\n.ed-box-title-sticky {\n\tposition: sticky;\n\ttop: 0px;\n\tbackground: @color1;\n\tcolor: @bg1;\n\tmargin-bottom: @padding;\n}\n\n.ed-box-content {\n\t// padding: 0px @padding;\n\tdisplay: flex;\n\talign-self: start;\n\tjustify-content: start;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n\n\n.ed-box,\n.ed-menu,\n.ed-input {\n\t&::-webkit-scrollbar {\n\t\t-webkit-appearance: none;\n\t\tbackground-color: @bg2;\n\t\twidth: 4px;\n\t\theight: 4px;\n\t\tborder-radius: 0px;\n\t}\n\n\t&::-webkit-scrollbar-corner {\n\t\tbackground-color: @bg2;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tborder-radius: 0px;\n\t\tbackground-color: #7F7F7F;\n\n\t\t&:hover {\n\t\t\tbackground-color: #8F8F8F;\n\t\t}\n\t}\n}\n\n.ed-box {\n\ttext {\n\t\tmargin-left: 10px;\n\t}\n\n\toverflow-y: scroll;\n\n\t&.ed-scroll {\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\t\twidth: 324px;\n\t}\n\n\t// box-shadow: inset 0px 0px 4px #00000052;\n\t// backdrop-filter: @blur;\n\tbackground-color: @bg1;\n\tcolor: @color1;\n\tposition: fixed;\n\twidth: 300px;\n\n\t// box-shadow: inset 0px 0px 2px #757575;\n\t// border: 1px solid black;\n\t// padding: @padding @padding2;\n\tflex-wrap: nowrap;\n\n\t.ed-description {\n\t\tpadding: 0px @padding;\n\t\t// padding-top: 0;\n\t\tfont-size: 0.8em;\n\t\tcolor: @color2;\n\t\tmargin: @padding 0px;\n\t\tmargin-top: 0px;\n\t\twhite-space: normal;\n\t\t// border-bottom: 3px solid @color2;\n\t}\n}\n\n// .ed-menu.ed-flex-right>.ed-menu.ed-flex-down{\n// \tmin-width: -webkit-fill-available;\n// }\n.ed-menu-child-wrapper {\n\tposition: relative;\n\tleft: -100%;\n\ttop: 12px;\n}\n\n.ed-menu {\n\t// box-shadow:  0px 0px 3px black;\n\tcolor: @color1;\n\tflex-wrap: nowrap;\n\twidth: fit-content;\n\theight: fit-content;\n\tposition: fixed;\n\n\t&.ed-scroll {\n\t\toverflow-y: scroll;\n\t\toverflow-x: hidden;\n\t}\n\n\t&.ed-flex-down {\n\t\t>.ed-menu-item {\n\t\t\twidth: -webkit-fill-available;\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\t&.ed-flex-right {\n\t\t>.ed-menu-item {\n\t\t\theight: -webkit-fill-available;\n\t\t\twidth: auto\n\t\t}\n\t}\n\n\t.ed-menu-labels {\n\t\tbackground-color: @bg1;\n\t\t// backdrop-filter: @blur;\n\t}\n\n\t.ed-menu-item-label {\n\t\twhite-space: pre;\n\t\t// background-color: @bg1;\n\t\tcolor: @color2;\n\t\twidth: -webkit-fill-available;\n\t\theight: @dim;\n\t\ttext-transform: uppercase;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolor: @color2;\n\t\tbackground: none;\n\t\tborder: none;\n\t\toutline: none;\n\t\tfont: inherit;\n\t\tpadding: 0px;\n\n\t\t&.ed-selected {\n\t\t\tbackground-color: @bg2;\n\t\t\t// backdrop-filter: @blur;\n\t\t\tcolor: @color1 !important;\n\t\t}\n\n\t\tcursor: pointer;\n\n\t\t// padding: 0px 12px;\n\t\t&:hover {\n\t\t\tcolor: @color1;\n\t\t\tbackground: @bg3;\n\t\t}\n\n\t}\n\n\t.ed-menu-item-box {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcolor: @color2;\n\t\tbackground: none;\n\t\toutline: none;\n\t\tpadding: 0px;\n\t\tborder: none;\n\n\t\t* {\n\t\t\tpointer-events: none;\n\t\t}\n\n\t\t&.ed-selected {\n\t\t\tbackground: @color2;\n\t\t\tcolor: @bg2 !important;\n\t\t}\n\n\t}\n\n\n\t.ed-menu-item {\n\t\tposition: relative;\n\t}\n\n\t&.ed-menu-alt {\n\n\t\t>.ed-menu-labels>.ed-menu-item-label {\n\t\t\tbackground-color: @bg2;\n\t\t}\n\n\t\t>.ed-menu-labels>.ed-menu-item-label.ed-selected {\n\t\t\tbackground-color: @bg1;\n\t\t}\n\t}\n}\n\n// .ed-menu-item-child{\n// \tposition: absolute;\n// \tleft: 0px;\n// \ttop: 0px;\n// }\n\n.ed-hidden {\n\tvisibility: hidden;\n}\n\n.ed-range-outer {\n\theight: @dim;\n\twidth: 100%;\n\tbackground: @bg2;\n\tposition: relative;\n\n\t.ed-range-slider {\n\t\twidth: 6.5px;\n\t\theight: @dim;\n\t\tbackground: @color1;\n\n\t\t&.ed-active {\n\t\t\tbackground: @color1;\n\t\t}\n\n\t}\n\n\t.ed-range-value {\n\t\tposition: absolute;\n\t\tleft: 14px;\n\t\ttop: 50%;\n\t\ttransform: translate(0%, -50%);\n\n\t\t&.ed-range-value-snap {\n\t\t\tright: 8px;\n\t\t\tleft: initial;\n\t\t}\n\n\t\t&.ed-range-value-left {\n\t\t\tright: 14px;\n\t\t\tleft: initial;\n\n\t\t\t&.ed-range-value-snap {\n\t\t\t\tleft: 8px;\n\t\t\t\tright: initial;\n\t\t\t}\n\t\t}\n\n\t}\n\n\tcursor: ew-resize;\n}\n\n.ed-button {\n\toutline: none;\n\t-webkit-appearance: none;\n\tfont: inherit;\n\tborder: none;\n\tcursor: pointer;\n\twidth: 100%;\n\theight: @dim;\n\tbackground: @bg2;\n\tcolor: @color2;\n\n\t&:hover {\n\t\tcolor: @color1;\n\t}\n}\n\n.ed-color-box {\n\tposition: relative;\n\t-webkit-appearance: none;\n\twidth: @dim * 2;\n\theight: @dim;\n\tflex-shrink: 0;\n\tcursor: pointer;\n\tmargin-right: @margin;\n\tborder: 3px solid black;\n\n\t.ed-color-box-input {\n\t\tvisibility: visible;\n\t\topacity: 0;\n\t\tcursor: pointer;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: absolute;\n\t\tpadding: 0px;\n\t\tleft: 0px;\n\t\ttop: 0px;\n\t}\n}\n\n.ed-value-box {\n\twidth: 100%;\n\t// flex-shrink: 1;\n\theight: @dim;\n\tbackground-color: @bg1;\n\tmargin-left: @margin*.6;\n\tline-height: @dim;\n\tpadding: 0px @padding;\n}\n\n\n\n.ed-section {\n\t// margin: 0px;\n\tmargin: @padding 0px;\n\tpadding: @padding 0px;\n\tposition: relative;\n\n\t// text-transform: uppercase;\n\t// margin-bottom: 2px;\n\tborder-top: 1px solid @color4;\n\tborder-bottom: 1px solid @color4;\n\t// margin-bottom: 200px;\n\t// padding: @padding;\n}\n\n.ed-section-title {\n\tmin-height: @dim;\n\tcursor: pointer;\n\twhite-space: pre;\n\n\tfont-weight: 800;\n\twidth: 100%;\n\tpadding: 0px @padding;\n\ttext-transform: uppercase;\n}\n\n.ed-section-label-toggle-off {\n\tcursor: default;\n}\n\n.ed-section-label-toggle {\n\tfont-size: @fontsize;\n\twidth: 100%;\n\tpadding-right: @padding;\n\tdisplay: flex;\n\tcolor: @color3;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tjustify-content: flex-end;\n\n\t&.ed-section-label-toggle-active {\n\t\tcolor: @color2;\n\t}\n}\n\n.ed-section-end-label {\n\tpadding: @padding;\n\tdisplay: flex;\n\twidth: 100%;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: center;\n\t// padding-left: @padding2;\n}\n\n.ed-input-select {\n\twidth: 100%;\n\toutline: none;\n\t-webkit-appearance: none;\n\theight: 24px;\n\tcursor: pointer;\n\tpadding: 0px @padding;\n\tborder: none;\n\tcolor: @color1;\n\tbackground: @bg2;\n}\n\n.ed-input-select-arrow {\n\tposition: absolute;\n\tright: 14px;\n\tcolor: @color3;\n\tfont-family: monospace;\n\n}\n\n.ed-separator {\n\tmargin-top: @dim / 3;\n\tborder-bottom: 1px solid @color4;\n\theight: 0px;\n\twidth: 100%;\n\tmargin-bottom: @dim / 2;\n}\n\n.ed-line-chart {\n\twidth: 100%;\n\theight: 80px;\n\tbackground: @bg2;\n}\n\n.ed-line-chart-wrap {\n\tflex-direction: column;\n\talign-content: flex-start;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\n\tcanvas {\n\t\tcursor: ew-resize;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n\n.ed-line-chart-label {\n\t// width: 50%;\n\tpadding: @padding 0px;\n}\n\n.ed-anchor {\n\tdisplay: flex;\n\tflex-direction: row;\n\tposition: fixed;\n\n\t.ed-anchor-handle {\n\t\tposition: fixed;\n\t\tbackground: black;\n\t\tcursor: move;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-content: center;\n\t\talign-items: center;\n\n\t\t.ed-anchor-dot {\n\t\t\tmargin: (@dim/6);\n\t\t\tpointer-events: none;\n\t\t\tbackground: white;\n\t\t\twidth: (@dim/6);\n\t\t\theight: (@dim/6);\n\t\t}\n\t}\n\n\t.ed-anchor-content {}\n\n\t.ed-anchor-handle-resize {\n\t\twidth: (@dim/2);\n\t\theight: (@dim/2);\n\t\tbackground: black;\n\t\tposition: absolute;\n\t\t// cursor: ns-resize;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tz-index: 1;\n\t}\n\n\t&.ed-anchor-drag {\n\t\tpointer-events: all;\n\t\tcursor: move;\n\n\t\t* {\n\t\t\tpointer-events: none !important;\n\t\t}\n\t}\n\n\t&.ed-anchor-resize {\n\t\tpointer-events: all;\n\n\t\t// cursor: ns-resize;\n\t\t* {\n\t\t\tpointer-events: none !important;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
